<template>
  <vetster-slide-over ref="quotePanel">
    <template #header>
      <div class="bg-neutral-50">
        <vetster-slide-over-common-heading
          :show-close="false"
          show-back
          @back="closeSlideOver"
        >
          <div class="text-2xl font-title leading-6 font-medium text-neutral-900">
            {{ $t('quote.choose-a-date') }}
          </div>
        </vetster-slide-over-common-heading>
        <vetster-date-button
          :date="defaultTimeslotDate"
          :timezone="getInputs.timezone"
          center-full-date
          class="mt-1"
          @update="onDayChange"
        />
        <div class="mt-3 grid grid-cols-3 border-t gap-3 px-standard border-b border-neutral-200 *:text-neutral-500 *:text-sm">
          <div class="flex items-center justify-center py-1">
            {{ $t('quote.morning') }}
          </div>
          <div class="flex items-center justify-center py-1">
            {{ $t('quote.afternoon') }}
          </div>
          <div class="flex items-center justify-center py-1">
            {{ $t('quote.evening') }}
          </div>
        </div>
      </div>
    </template>
    <template #content>
      <vetster-quote-panel
        :partner="partner"
        :default-date="defaultTimeslotDate"
        :default-timeslot="getSelectedAppointment"
        :default-timezone="timezone"
      />
    </template>
    <template #footer>
      <vetster-quote-total
        is-quote-panel
        @checkout="$emit('checkout')"
      />
    </template>
  </vetster-slide-over>
</template>

<script>
import { mapGetters } from 'vuex';

import VetsterDateButton from '@/brand-components/GuidedSearch/VetsterDateButton';
import VetsterQuotePanel from '@/brand-components/GuidedSearch/VetsterQuotePanel';
import VetsterQuoteTotal from '@/brand-components/GuidedSearch/VetsterQuoteTotal';
import VetsterSlideOver from '@/brand-components/VetsterSlideOver';
import VetsterSlideOverCommonHeading from '@/brand-components/VetsterSlideOverCommonHeading';
import useSmartTime from '@/composables/use-smart-time';

export default {
  name: 'VetsterPartnerQuotePanelSlideOver',

  components: {
    VetsterDateButton,
    VetsterQuotePanel,
    VetsterQuoteTotal,
    VetsterSlideOver,
    VetsterSlideOverCommonHeading,
  },

  props: {
    partner: {
      type: Object,
      required: true,
    },
    timezone: {
      type: String,
      default: undefined,
    },
    searchParams: {
      type: Object,
      default: () => ({}),
    },
  },

  setup() {
    const { validDateFrom } = useSmartTime();

    return { validDateFrom };
  },

  computed: {
    ...mapGetters('quote', ['getInputs']),

    getFirstAvailableAppointment() {
      return this.partner?.appointments[0];
    },

    getSelectedAppointment() {
      if (this.getInputs.timeslot) {
        return this.getInputs.timeslot;
      }

      return this.getFirstAvailableAppointment;
    },
    defaultTimeslotDate() {
      return this.validDateFrom(this.getInputs.timeslot.start_at);
    },
  },

  methods: {
    closeSlideOver() {
      this.$emit('back');
      this.$refs.quotePanel.close();
    },

    openSlideover() {
      this.$refs.quotePanel.open();
    },

    async onDayChange(date) {
      await this.$store.dispatch('quote/setDateAndFetchAvailability', date);
    },
  },
};
</script>
